import { render, staticRenderFns } from "./SelectSection.vue?vue&type=template&id=1f0e45c9&"
import script from "./SelectSection.vue?vue&type=script&lang=js&"
export * from "./SelectSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/Kristian/Local Sites/boligvelger/app/public/wp-content/plugins/ensign-boligprosjekter-blocks/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f0e45c9')) {
      api.createRecord('1f0e45c9', component.options)
    } else {
      api.reload('1f0e45c9', component.options)
    }
    module.hot.accept("./SelectSection.vue?vue&type=template&id=1f0e45c9&", function () {
      api.rerender('1f0e45c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SelectSection.vue"
export default component.exports